@if (isCallback()) {
  <!-- Callback de Keycloak -->
  <app-callback></app-callback>
} @else if (isPublicFullScreenRoute() && !isCallback()) {
  <!-- Página pública a pantalla completa (ej. éxito de pago Paycode), sin auth ni layout -->
  <router-outlet></router-outlet>
} @else if (!isAuthenticated()) {
  <!-- No autenticado: pantalla de verificación antes de redirigir a Keycloak -->
  <div class="flex items-center justify-center min-h-screen bg-slate-100">
    <div class="text-center">
      <div class="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mb-4"></div>
      <p class="text-slate-700 text-lg font-medium">Verificando acceso</p>
      <p class="text-slate-500 text-sm mt-2">Redirigiendo al inicio de sesión...</p>
    </div>
  </div>
} @else {
  <div class="relative h-screen overflow-hidden lg:flex">
    <!-- Sidebar -->
    <app-sidebar 
      class="fixed inset-y-0 left-0 z-10 w-72 h-screen transform transition-transform duration-300 ease-in-out lg:translate-x-0 lg:static lg:h-screen"
      [class.translate-x-0]="isSidebarOpen()"
      [class.-translate-x-full]="!isSidebarOpen()"
      (toggleSidebar)="toggleSidebar()"
      [activeRoute]="currentRoute()"
      (close)="closeSidebar()">
    </app-sidebar>

    <!-- Overlay for mobile -->
    @if (isSidebarOpen()) {
      <div (click)="closeSidebar()" class="fixed inset-0 bg-black/60 z-40 lg:hidden"></div>
    }

    <!-- Main Content -->
    <div class="flex-1 flex flex-col overflow-hidden h-full">
      <app-navbar (toggleSidebar)="toggleSidebar()"></app-navbar>
      <app-global-search-launcher />
      <main class="flex-1 min-h-0 overflow-y-auto p-4 sm:p-8 bg-slate-100 flex flex-col">
        <router-outlet (activate)="closeSidebar()"></router-outlet>
      </main>
    </div>

    <!-- Task Modal -->
  </div>
}

<p-confirmDialog acceptButtonStyleClass="p-button-danger" />
